import axios from 'axios';
import * as jose from 'jose'
import appConfig from '../Config/appConfig';

const generateJWT = async () => {
    try {
        const secret = new TextEncoder().encode(appConfig.TimeStamp);
        const token = await new jose.SignJWT()
            .setProtectedHeader({ alg: 'HS256' })
            .setIssuedAt()
            .setExpirationTime('1h')
            .sign(secret);
        return token;
    } catch (error) {
        console.error("Error generating JWT:", error);
        throw error;
    }
};

// Generous timeout — Epic/FHIR-backed operations can be slow; too short a value would
// falsely trigger useTask.js's network-error retry on a call that was still succeeding.
const api = axios.create({ timeout: 30000 });

api.interceptors.request.use(
    async (config) => {
        try {
            const token = await generateJWT();

            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }

            return config;
        } catch (error) {
            console.error("Error in request interceptor:", error);
            return Promise.reject(error);
        }
    },
    (error) => {
        console.error("Error in request interceptor (rejection):", error);
        return Promise.reject(error);
    }
);

export default api;